import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {DeleteData, GetAllData} from './LandingPageSlice/LandingPageSlice'
import NodataYet from '../../../Components/NodataYet'

const LandingPageList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  const [editData, setEditData] = useState<any>()
  const [landingPage, setLandingPage] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()

  const LandingPageList = useSelector((state: any) => state?.LandingPage?.landingPage?.data)

  const objectofLandingPage = {
    header: {
      name: 'landingpage name',
      media: 'url of image or video',
      logoMedia: 'url for logo',
    },
    Quote: [
      {
        data: 'test1',
      },
      {
        data: 'test1',
      },
      {
        data: 'test1',
      },
    ],
    Bullet_Points: [
      {
        data: 'test1',
      },
      {
        data: 'test1',
      },
      {
        data: 'test1',
      },
    ],
    Where_when: {
      Event_title: '',
      Event_des: '',
      add: '',
      start: '',
      end: '',
      addRSVP: '',
    },
  }

  const rsvp = {
    email: '',
    title: '',
    options: ['option1', 'option2', 'option3', 'option4'],
  }

  useEffect(() => {
    dispatch(GetAllData())
  }, [])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteData({
          id: deleteIds,
        })
      )
      setConfirm(false)
    }
  }, [confirm])

  const handleEdit = (val: any) => {
    navigate('/create-langing-page', {state: val})
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete Template?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const handleSingleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  return (
    <>
      {confirmation}
      <div className='card mb-0'>
        <div className='card-header border-0 pt-8 px-9'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Landing pages</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
          </h3>
          {AuthenticateUser('create-landing-page') && (
            <div className='card-toolbar m-0'>
              <div className='d-flex gap-3 align-items-center'>
                <button
                  className='btn btn-primary'
                  onClick={() => navigate('/create-langing-page')}
                >
                  Create New
                </button>
              </div>
            </div>
          )}
        </div>
        {LandingPageList?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>NAME</th>
                      <th>Opening Screen</th>
                      <th>Quote</th>
                      <th>Benefits and Offers</th>
                      <th>Time & Date</th>
                      <th>Add to Calendar</th>
                      <th>Guest RSVP</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {LandingPageList?.map((val: any, i: number) => {
                      return (
                        <tr key={i}>
                          <td className='fw-bolder'>{val?.campaignName || '--'}</td>
                          <td>
                            {val?.header?.name == 'header' &&
                            val?.header?.campaignMessage !== '' ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>
                          <td>
                            {val?.quote?.name == 'quote' &&
                            val?.quote?.data?.[0]?.content !== '' ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>
                          <td>
                            {val?.bulletPoints?.name == 'bulletPoints' &&
                            (val?.bulletPoints?.data?.[0]?.content !== '' ||
                              val?.bulletPoints?.data?.length > 1) ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>
                          <td>
                            {val?.whereWhen?.name == 'whereWhen' &&
                            val?.header?.eventTitle !== '' ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>
                          <td>
                            {val?.rsvpButtons == true && val?.header?.eventTitle !== '' ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>
                          <td>
                            {val?.rsvp?.name == 'rsvp' && val?.header?.title !== '' ? (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/check-circle.svg')}
                              />
                            ) : (
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/art/cross-square.svg')}
                              />
                            )}
                          </td>

                          <td>
                            <div className='row'>
                              {AuthenticateUser('edit-landing-page') && (
                                <a
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'
                                  onClick={() => handleEdit(val)}
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <i className='bi bi-pencil-fill'></i>
                                  </span>
                                </a>
                              )}
                              {AuthenticateUser('delete-landing-page') && (
                                <a
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3 delete_action trash'
                                  onClick={() => handleSingleDelete(val?._id)}
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <KTSVG
                                      path='/media/icons/duotune/art/trush.svg'
                                      className='svg-icon-3'
                                    />
                                  </span>
                                </a>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                {/* <div className='abcd '>
                    <select onChange={(e: any)=> setPage({...page, size: e.target.value, page: 1})}>
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={tagslist?.total}>ALL</option>
                    </select>
                    <ReactPaginate previousLabel='<' nextLabel='>' pageCount={tagslist?.totalPages} onPageChange={(e)=>
                      setPage({...page, page: e.selected + 1})}
                      containerClassName={'pagiantion'}
                      previousLinkClassName={'pagination__link'}
                      nextLinkClassName={'pagination__link'}
                      disabledClassName={'pagination__link--disabled'}
                      activeClassName={'pagination__link--active'}
                      />
                  </div> */}
              </div>
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default LandingPageList
